import React from 'react';
import { ColumnKey } from '../UserManagement/PlanningTable';
import { IconButton } from '@mui/material';
import { ArrowDownward, ArrowUpward } from '@mui/icons-material';
type Props = {
  onClick: (id: ColumnKey) => void;
  direction: string;
  id: ColumnKey;
  isSorted: boolean;
}
const SortIcon = ({ onClick, direction, id, isSorted }: Props) => {
  return (
    <IconButton size={'small'} onClick={() => onClick(id)}>
      {direction === 'desc' && isSorted ? <ArrowDownward fontSize={'small'}/> : <ArrowUpward fontSize={'small'}/>}
    </IconButton>
  );
};

export default SortIcon;